import { cloud } from '../http';
import { get } from 'svelte/store';

// Stores
import { devices_status } from 'src/stores/device-runtime/status';

// Types
import type { GetThermostatsStatusResponse } from 'src/types/responses/GetThermostatsStatus';
import type { ThermostatStatus } from 'src/types/ThermostatStatus';

export async function getThermostatsStatus() {
	const res = await fetchThermostatsStatus();

	if (res?.error) {
		console.error('Error while fetching the devices thermostats statuses', res);
		return;
	}

	const data: GetThermostatsStatusResponse = res;
	updateThermostatsStatus(data);
}

// Fetch device state from the IOTU v2 API
async function fetchThermostatsStatus() {
	return await cloud.get('/v2/scenes/thermostats');
}

// Build the devices status from the response data
function buildThermostatsStatus(data: GetThermostatsStatusResponse) {
	return data
		.map((thermostat) => ({
			[thermostat.id]: { thermostat: thermostat.state },
		}))
		.reduce(
			(acc, curr) => {
				return { ...acc, ...curr };
			},
			{} as Record<string, ThermostatStatus>,
		);
}

// Update the devices status in the store
function updateThermostatsStatus(data: GetThermostatsStatusResponse) {
	const thermostatStatus = buildThermostatsStatus(data);
	// Will add to the status for now as it was here before. Will create a task to extract ot a dedicated store.
	devices_status.set({
		...get(devices_status),
		...thermostatStatus,
	});
}
